import cx from 'classnames';
import { DatePicker } from 'llui';
import moment from 'moment';
import { FormGroup } from 'tombac';
import DateRangeLimitSummary from "../limit-summaries/DateRangeLimitSummary";
import "./DateRangeLimitEditor.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const format = 'DD/MM/YYYY';
export default function DateRangeLimitEditor({
  className,
  defaultLimit = null,
  label,
  limit = null,
  onChange,
  schema
}) {
  const from = limit && limit.from && moment(limit.from);
  const to = limit && limit.to && moment(limit.to);
  function handleChange(key, value) {
    const newLimit = {
      ...limit
    };
    newLimit[key] = value && value.toDate();
    if (onChange) onChange(newLimit.from || newLimit.to ? newLimit : null);
  }
  return /*#__PURE__*/_jsx(FormGroup, {
    $width: "100%",
    className: cx('DateRangeLimitEditor', className),
    label: label,
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "DateRangeLimitEditor",
    "data-sentry-source-file": "DateRangeLimitEditor.tsx",
    children: schema.customizable ? /*#__PURE__*/_jsxs("div", {
      className: "DateRangeLimitEditor__inputs-container",
      children: [/*#__PURE__*/_jsx("div", {
        className: "DateRangeLimitEditor__input",
        children: /*#__PURE__*/_jsx(DatePicker, {
          dateFormat: format,
          endDate: to,
          isClearable: true,
          onChange: value => handleChange('from', value),
          placeholderText: defaultLimit !== null && defaultLimit.from ? moment(defaultLimit.from).format(format) : 'Unlimited',
          selected: from,
          selectsStart: true,
          showMonthDropdown: true,
          showYearDropdown: true,
          startDate: from
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "DateRangeLimitEditor__separator",
        children: " \u2013 "
      }), /*#__PURE__*/_jsx("div", {
        className: "DateRangeLimitEditor__input",
        children: /*#__PURE__*/_jsx(DatePicker, {
          dateFormat: format,
          endDate: to,
          isClearable: true,
          minDate: from,
          onChange: value => handleChange('to', value),
          placeholderText: defaultLimit !== null && defaultLimit.to ? moment(defaultLimit.to).format(format) : 'Unlimited',
          selected: to,
          selectsEnd: true,
          showMonthDropdown: true,
          showYearDropdown: true,
          startDate: from
        })
      })]
    }) : /*#__PURE__*/_jsx(DateRangeLimitSummary, {
      className: "LimitEditor__value",
      limit: limit || defaultLimit,
      schema: schema,
      variant: "basic"
    })
  });
}